import React from 'react'

const PersonIcon = (({fill = '#FFF'}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" 
      width="8.001" 
      height="17.336" 
      viewBox="0 0 8.001 17.336"
    >
    <path fill={fill} d="M-1801.5,20788.023a1.686,1.686,0,0,1-1.251-.525,1.742,1.742,0,0,1-.516-1.27v-3.148a1.674,1.674,0,0,1-.95-.627,1.737,1.737,0,0,1-.383-1.1v-3.555a2.478,2.478,0,0,1,.45-1.457,2.447,2.447,0,0,1,1.183-.914,2.91,2.91,0,0,1-.566-1.76,2.889,2.889,0,0,1,.866-2.1,2.8,2.8,0,0,1,2.066-.881,2.8,2.8,0,0,1,2.068.881,2.888,2.888,0,0,1,.866,2.1,2.912,2.912,0,0,1-.567,1.76,2.452,2.452,0,0,1,1.184.914,2.478,2.478,0,0,1,.45,1.457v3.555a1.744,1.744,0,0,1-.383,1.1,1.672,1.672,0,0,1-.95.627v3.148a1.737,1.737,0,0,1-.517,1.27,1.681,1.681,0,0,1-1.25.525Z" transform="translate(1804.602 -20770.688)"/>
    </svg>
  )
})

export {PersonIcon}